import React from "react";
import { Link } from "react-router-dom";
import { loginFields } from "../../utils/utils";
import LoginWrapper from "../hoc/LoginWrapper";
import Card from "../shared/Card";
import FormField from "./utilComponents/FormField";
import Divider from "../shared/Divider";
import FormButton from "../shared/FormButton";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { login } from "../../features/auth/actions/auth";

const SignInSchema = Yup.object().shape({
  username: Yup.string().min(3).max(45).required("This field is required"),
  password: Yup.string()
    .min(8, "Password should be atleast 8 characters in length")
    .max(20, "Password should not exceed 20 characters")
    .required("This field is required"),
});

const Login = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.auth.loading); 

  return (
    <Card>
      <div className="mb-8">
       <div className="font-bold text-lg">Welcome</div>
        <div>
          Provide your username and password to signin into your account.
        </div>
      </div>
      <Formik
        initialValues={{
          username: "",
          password: "",
        }}
        validationSchema={SignInSchema}
        onSubmit={(values) => dispatch(login(values))}
      >
        {() => (
          <Form>
            {loginFields.map((field) => (
              <FormField key={field.name} {...field} />
            ))}
            <div className="flex justify-start mb-2">
              Forgot password? &nbsp;{" "}
              <Link to="reset-password" className="text-[#3e4095]">
                Reset here
              </Link>
            </div>
          <Divider />
             <FormButton isSubmitting={loading} buttonText="Sign In" />
            </Form>
        )}
      </Formik>
    </Card>
  );
};

export default LoginWrapper(Login);
